import { toast } from "react-toastify";

export function handleError(error) {
  toast.error(`Ошибка: ${error.message}`, {
    position: "top-center",
    autoClose: 25000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
}

export function handleSuccess() {
  toast.success("Версия приложения 3.1.0", {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
}
